var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertInner',[_c('BaseLoading'),_vm._v(" "),_c('h2',{class:_vm.$style.title},[_vm._v("请稍候")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }